import { jsx as _jsx } from "react/jsx-runtime";
const Spinner = ({ className }) => (_jsx("div", { className: `animate-spin rounded-full border border-solid border-info border-r-transparent ${className}` }));
export default Spinner;
